import React from "react";

const contactDetails = [
  {
    icon: (
      <svg width={20} height={20} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
      </svg>
    ),
    label: "Our Location",
    value: "Flat No – 706, B-wing Sai Vihar Chs., Sector 15 CBD Belapur, Navi Mumbai – 400614, Maharashtra.",
    href: null,
  },
  {
    icon: (
      <svg width={20} height={20} viewBox="0 0 24 24" fill="currentColor">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
      </svg>
    ),
    label: "Phone",
    value: "+91 9769847865",
    href: "tel:+919769847865",
  },
  {
    icon: (
      <svg width={20} height={20} viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
      </svg>
    ),
    label: "Email",
    value: "info@bfiinfotech.co.in",
    href: "mailto:info@bfiinfotech.co.in",
  },
];

const ContactSection = () => (
  <section className="bg-white py-10 md:py-16 lg:py-24 px-5 lg:px-12 relative z-10 w-full">
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 lg:items-start">

        {/* contact info */}
        <div className="w-full lg:w-5/12" data-aos="fade-right">
          <div className="mb-6">
            <span className="text-blue-600 font-bold tracking-[2px] uppercase text-[10px] border-b-2 border-blue-400 pb-1 inline-block mb-4">
              Contact Us
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-teko uppercase text-slate-900 tracking-wide leading-tight mb-3">
              Let's <span className="text-blue-600">Connect</span>
            </h2>
            <p className="text-sm md:text-base text-slate-600 leading-relaxed">
              Have a question or a doubt in mind? Our team is ready to help you.
            </p>
          </div>

          <div className="space-y-4 md:space-y-6">
            {contactDetails.map((item, idx) => (
              <div key={idx} className="flex items-start gap-4">
                <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center text-blue-600 flex-shrink-0">
                  {item.icon}
                </div>
                <div>
                  <h4 className="text-sm font-bold text-slate-900">{item.label}</h4>
                  {item.href ? (
                    <a
                      href={item.href}
                      className="text-slate-500 text-xs md:text-sm hover:text-blue-600 transition-colors"
                    >
                      {item.value}
                    </a>
                  ) : (
                    <p className="text-slate-500 text-xs md:text-sm leading-relaxed">
                      {item.value}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* contact form */}
        <div className="w-full lg:w-7/12" data-aos="fade-left">
          <div className="p-6 md:p-8 bg-slate-50 rounded-2xl border border-slate-100 shadow-sm">
            <h3 className="text-lg md:text-xl font-teko uppercase text-slate-900 tracking-wide mb-5">
              Send Us a Message
            </h3>
            <form>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <input
                  type="text"
                  placeholder="Name"
                  className="w-full bg-white rounded-lg border border-slate-200 py-3 px-4 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-200 outline-none transition-all"
                />
                <input
                  type="email"
                  placeholder="Email"
                  className="w-full bg-white rounded-lg border border-slate-200 py-3 px-4 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-200 outline-none transition-all"
                />
              </div>
              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full bg-white rounded-lg border border-slate-200 py-3 px-4 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-200 outline-none mb-4 transition-all"
              />
              <textarea
                rows="4"
                placeholder="Your Message"
                className="w-full bg-white rounded-lg border border-slate-200 py-3 px-4 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-200 outline-none mb-5 resize-none transition-all"
              />
              <button
                type="submit"
                className="w-full py-3 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white rounded-lg font-bold uppercase tracking-wider text-xs transition-all shadow-md shadow-blue-100"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>

      </div>
    </div>
  </section>
);

const Contact = () => (
  <div className="bg-white min-h-screen overflow-x-hidden">
    <div data-theme="dark" className="h-48 md:h-64 relative flex items-center justify-center text-white overflow-hidden bg-gradient-to-b from-[#060b13] via-[#0b172a] to-[#050a12] rounded-b-[2.5rem] border-b border-blue-900/30 pt-[82px]">
      <div
        className="absolute inset-0 opacity-15"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.06) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.06) 1px,transparent 1px)",
          backgroundSize: "28px 28px",
        }}
      />
      {/* gradient blobs */}
      <div className="absolute top-0 right-0 w-72 h-72 rounded-full bg-blue-600/25 blur-[80px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-indigo-600/15 blur-[80px] pointer-events-none" />

      <div className="text-center px-4 relative z-10" data-aos="zoom-out">
        <h1 className="text-3xl md:text-5xl font-teko uppercase tracking-wider">
          Contact Us
        </h1>
        <div className="w-12 h-1 bg-blue-500 mx-auto mt-2 rounded-full" />
      </div>
    </div>

    <ContactSection />
  </div>
);

export default Contact;
